/**
 * @generated SignedSource<<12adefbc05f822f8dbf2b9ac2623a58d>>
 * @relayHash 3e3db3d98f54348bf076f0d6f0e7fd84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5bb26740db188792802494ee5d7fcebdba29de8696e2a93973ea7e2b37e823a1

import type { ConcreteRequest } from 'relay-runtime';
export type ExcerptIncludeTargetPageQuery$variables = {
  contentTitle: string;
  spaceKey: string;
  type: string;
};
export type ExcerptIncludeTargetPageQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly body: {
        readonly atlas_doc_format: {
          readonly value: string | null;
        } | null;
      } | null;
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type ExcerptIncludeTargetPageQuery = {
  response: ExcerptIncludeTargetPageQuery$data;
  variables: ExcerptIncludeTargetPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentTitle"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "contentTitle"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExcerptIncludeTargetPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExcerptIncludeTargetPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3e3db3d98f54348bf076f0d6f0e7fd84",
    "id": "5bb26740db188792802494ee5d7fcebdba29de8696e2a93973ea7e2b37e823a1",
    "metadata": {},
    "name": "ExcerptIncludeTargetPageQuery",
    "operationKind": "query",
    "text": "query ExcerptIncludeTargetPageQuery($contentTitle:String!,$spaceKey:String!,$type:String!){content(title:$contentTitle,spaceKey:$spaceKey,type:$type){nodes{id,body{atlas_doc_format{value}}}}}"
  }
};
})();

(node as any).hash = "24784cacd20eb176d07d5b258bf8a67f";

export default node;
